import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { ZoomerComponent } from './components/zoomer/zoomer.component';
import { NavbarComponent } from './navbar.component';



@NgModule({
  declarations: [NavbarComponent, ZoomerComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [NavbarComponent, ZoomerComponent]
})
export class NavbarModule { }
